
import { createTheme, colors } from '@mui/material';

// A custom theme for this app
const theme = createTheme({
  color: {
    white: '#ffffff',
    black: '#000000',
    pearl: '#F4F4F4',
    pale: '#EBEBEB',
    silver: '#D9D9D9',
    stone: '#7B7A7A',
    graphite: '#2B2A2A',
    charcoal: '#1E1E1E',
    shadow: '#202020',
    tea: '#ECFFD9',
    lemon: '#9FC131',
    sheen: '#92B228',
    peach: '#FFF6E1',
    honey: '#F2A007',
    apricot: '#F28705',
    desire: '#FFE0D9',
    ruby: '#BD2424',
    safire: '#A51C1C',
    denim: '#0B3DA5',
    navy: '#13314D',
    aegon: '#011740',
    space: '#142337',
    arctic: '#DBE8FF',
    pacific: '#C1D1EE',
  },
  palette: {
    primary: {
      main: '#556cd6',
    },
    secondary: {
      main: '#fafafa',
      dark: '#7e7d7d',
    },
    error: {
      main: colors.red.A400,
    },
    neutral: {
      main: colors.grey[500],
      darker: colors.grey[800],
    },
    background: {
      default: '#fff',
    },
  },
});

export default theme;